import { createContext } from "react";
export const SettingsContext = createContext(null);
export const NavigationContext = createContext(null);
export const PagesContentContext = createContext(null);
export const HomePageContentContext = createContext(null);
export const LoadingContext = createContext(null);
export const SendInBlueContext = createContext(null);
